import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import Box from "@mui/material/Box";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

let adSizes = [];
let iabSizes = [];
let mobileSizes = [];
let otherSizes = [];

function getStyles(name, focusSeriesName, theme) {
	return {
		fontWeight: focusSeriesName.includes(name)
			? theme.typography.fontWeightMedium
			: theme.typography.fontWeightRegular
	};
}

function AdSizeDropDown({
	adData,
	getAdFocusSizes,
	theFocusAdSize,
	theFocusRegion,
	theFocusEnv,
	theFocusCampaign
}) {
	const [focusAdSizes, setFocusAdSizes] = React.useState(theFocusAdSize);
	const [allAdSizes, setAllAdSizes] = React.useState([]);

	React.useEffect(() => {
		if (theFocusCampaign && theFocusRegion) {
			adSizes = [];
			iabSizes = [];
			mobileSizes = [];
			otherSizes = [];
			adData.map((ad) => {
				if (
					ad.region == theFocusRegion &&
					ad.campaign == theFocusCampaign &&
					ad.environment == theFocusEnv
				) {
					if (ad.ad_group.toLowerCase() == "iab") {
						iabSizes.push(ad.width + "x" + ad.height);
					} else if (ad.ad_group.toLowerCase() == "mobile") {
						mobileSizes.push(ad.width + "x" + ad.height);
					} else {
						otherSizes.push(ad.width + "x" + ad.height);
					}
				}
			});
			adSizes = [...new Set(iabSizes.concat(otherSizes, mobileSizes))];

			// adSizes = [...new Set(adSizes)];

			setAllAdSizes(adSizes);

			setFocusAdSizes(theFocusAdSize);
		}
	}, [theFocusRegion, theFocusCampaign, theFocusEnv]);

	const handleChange = (event) => {
		//console.log(event.target.value);
		//send event.target.value to app.js
		getAdFocusSizes(event.target.value);
		const {
			target: { value }
		} = event;
		setFocusAdSizes(
			// On autofill we get a stringified value.
			typeof value === "string" ? value.split(",") : value
		);
	};

	const handleClose = () => {
		//setFocusAdSizes([]);
		//getAdFocusSizes([]);
		// console.log("Select closed");
	};
	const handleOpen = () => {
		// console.log("Select opened");
	};
	const handleClear = () => {
		// console.log("clear ad sizes");
		setFocusAdSizes([]);
		getAdFocusSizes([]);
	};

	return (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			}}
		>
			<FormControl sx={{ m: 1, width: 230 }}>
				{
					// <IconButton
					// 	aria-label="close"
					// 	onClick={handleClear}
					// 	sx={{ position: "absolute", right: 40, top: 8, zIndex: 50 }}
					// >
					// 	<CloseIcon />
					// </IconButton>
				}
				<InputLabel id="demo-multiple-checkbox-label">Ad Sizes</InputLabel>
				<Select
					labelId="demo-multiple-checkbox-label"
					id="demo-multiple-checkbox"
					multiple
					value={focusAdSizes ? focusAdSizes : ""}
					onChange={handleChange}
					// onOpen={() => handleOpen()}
					// onClose={() => handleClose()}
					input={<OutlinedInput label="Ad Sizes" />}
					renderValue={(selected) => selected.join(", ")}
					MenuProps={MenuProps}
				>
					{iabSizes.length > 0 && (
						<div>
							<Divider />
							<Button
								variant="outlined"
								color="primary"
								onClick={() => {
									setFocusAdSizes(iabSizes);
									getAdFocusSizes(iabSizes);
								}}
								sx={{
									width: 230,
									height: 30,
									borderRadius: 0,
									fontSize: 9,
									width: 230
								}}
								disabled={iabSizes.length == 0}
							>
								IAB
							</Button>
						</div>
					)}
					{iabSizes.map((size) => (
						<MenuItem key={size} value={size} className="iabsizes">
							<Checkbox checked={focusAdSizes.includes(size)} />
							<ListItemText primary={size} />
						</MenuItem>
					))}

					{otherSizes.length > 0 && (
						<div>
							<Divider />
							<Button
								variant="outlined"
								color="primary"
								onClick={() => {
									setFocusAdSizes(otherSizes);
									getAdFocusSizes(otherSizes);
								}}
								sx={{
									height: 30,
									borderRadius: 0,
									fontSize: 9,
									width: 230
								}}
								disabled={otherSizes.length == 0}
							>
								Other
							</Button>
						</div>
					)}
					{otherSizes.map((size) => (
						<MenuItem key={size} value={size} className="mobilesizes">
							<Checkbox checked={focusAdSizes.includes(size)} />
							<ListItemText primary={size} />
						</MenuItem>
					))}

					{iabSizes.length > 0 && (
						<div>
							<Divider />
							<Button
								variant="outlined"
								color="primary"
								onClick={() => {
									setFocusAdSizes(mobileSizes);
									getAdFocusSizes(mobileSizes);
								}}
								sx={{
									height: 30,
									borderRadius: 0,
									fontSize: 9,
									width: 230
								}}
								disabled={mobileSizes.length == 0}
							>
								Mobile
							</Button>
						</div>
					)}
					{mobileSizes.map((size) => (
						<MenuItem key={size} value={size} className="othersizes">
							<Checkbox checked={focusAdSizes.includes(size)} />
							<ListItemText primary={size} />
						</MenuItem>
					))}
				</Select>
			</FormControl>
			<div
				style={{
					display: "flex",
					gap: "0px",
					flexDirection: "column"
				}}
			>
				<Button
					variant="outlined"
					color="primary"
					onClick={() => {
						setFocusAdSizes(allAdSizes);
						getAdFocusSizes(allAdSizes);
					}}
					sx={{
						height: 25,
						borderRadius: 0,
						fontSize: 9
					}}
					disabled={adSizes.length == 0}
				>
					All
				</Button>

				<Button
					variant="outlined"
					color="primary"
					onClick={handleClear}
					sx={{
						height: 25,
						borderRadius: 0,
						fontSize: 9
					}}
					disabled={focusAdSizes == 0}
				>
					Clear
				</Button>
			</div>
		</div>
	);
}
export default AdSizeDropDown;
